import React from 'react';
import { Link } from 'gatsby';
import HouseIcon from '../../images/house-solid.svg';
import ChevronRight from '../../images/chevron-right-alternative.svg';
import Container from './grid/container';
import StyledLink from './styled-link';

interface BreadcrumbsProps {
    crumbs?: { text?: string | null, url?: string | null }[]
    sliceFirst?: boolean
}

/*
* These are controlled by Yoast.
* Breadcrumb updates must be done in the Yoast Panel on each individual page.
*
* Yoast will automatically create breadcrumbs based on page structure, but if you
* wish to alter these, they will need to be changed within the plugin UI.
* */

const Breadcrumbs = ({ crumbs, type, postTypeCrumb, sliceFirst = true }: BreadcrumbsProps) => {

    crumbs = type === 'search-results' && crumbs?.length > 3 ? crumbs?.slice(-(crumbs?.length), -1) : crumbs
    crumbs = sliceFirst ? crumbs?.slice(sliceFirst ? 1 : 0) : crumbs;
    postTypeCrumb && crumbs?.unshift(postTypeCrumb);

    return (
        <Container
            css={{
                display: 'flex',
                paddingTop: type === 'search-results' ? '12px' : '22px',
                paddingBottom: '12px',
                paddingLeft: type === 'search-results' ? '0!important' : '',
                backgroundColor: 'var(--color-gray-white)',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                overflowX: type === 'search-results' ? 'hidden' : 'auto',
                '&::-webkit-scrollbar': {
                    height: '10px',
                    borderTop: '9px solid #fff',
                    backgroundColor: 'var(--color-gray-almostwhite)',
                },
                '&::-webkit-scrollbar-thumb': {
                    height: '10px',
                    borderTop: '9px solid #fff',
                    backgroundClip: 'padding-box',
                    backgroundColor: 'var(--color-blue-mittelblau)',
                },
            }}
        >
            { type !== 'search-results' && (
                <Link to="/">
                    <HouseIcon css={{
                        height: '20px',
                        marginBottom: '2px',
                    }}
                    />
                </Link>
            )}
            {crumbs && crumbs?.map(({ text, url }, index) => (
                <React.Fragment key={index}>
                    { ((type === 'search-results' && index !== 0) || type !== 'search-results') && (
                        <div
                            css={{
                                paddingLeft: '20px',
                                '@media (max-width: 767px)': {
                                    paddingLeft: '10px',
                                },
                            }}
                        >
                            <ChevronRight css={{
                                height: '12px',
                            }}
                            />
                        </div>
                    )}
                    <StyledLink
                        small
                        to={url || ''}
                        className="p3"
                        css={{
                            color: '#2A2A2A',
                            marginLeft: ((type === 'search-results' && index !== 0) || type !== 'search-results') ? '16px' : 0,
                            whiteSpace: 'nowrap',
                            '@media (max-width: 767px)': {
                                marginLeft: ((type === 'search-results' && index !== 0) || type !== 'search-results') ? '8px' : 0,
                            },
                        }}
                    >
                        <span
                            dangerouslySetInnerHTML={{ __html: type === 'search-results' && index === crumbs?.length - 1 && text.length > 30 ? `${text?.substring(0, 31).trim()}...` : text }}
                        />
                    </StyledLink>
                </React.Fragment>
            ))}
        </Container>
    );
}

export default Breadcrumbs;
